import { render, staticRenderFns } from "./VxImagePreview.vue?vue&type=template&id=b51495aa&scoped=true"
import script from "./VxImagePreview.vue?vue&type=script&lang=js"
export * from "./VxImagePreview.vue?vue&type=script&lang=js"
import style0 from "./VxImagePreview.vue?vue&type=style&index=0&id=b51495aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b51495aa",
  null
  
)

export default component.exports